import React from 'react'
import { BaseBadge } from './BaseBadge'
import { Tooltip } from '../ui/tooltip'
import { updateStatusBadgeOptions, updateStatusMetaById } from '../../constants/update_status'

export const UpdateStatusBadge = ({ status_id }) => {
    const metadata = updateStatusMetaById[status_id]
    if (!metadata) {
        console.error('Cannot resolve status badge for', status_id)
        return <span className="bp4-tag bp4-minimal">{String(status_id)}</span>
    }

    const badge = <BaseBadge options={updateStatusBadgeOptions} value={status_id} />

    return (
        <Tooltip content={metadata.description} position="top">
            {badge}
        </Tooltip>
    )
}
